import { isDevPortal } from "../../Utils/devPortal";

// LOCAL DEV - core toothlens-APIs on :3002 (local Mongo). Switch back before committing.
// export const API_HOST = "http://localhost:3002/api/v1/";

export const API_HOST = "https://portal-dev.toothlens.com/api/v1/";
// export const API_HOST = "https://portal.toothlens.com/api/v1/";

// REACT_APP_API_HOST (read at `npm start` / build time) overrides it without editing this file —
// used by the cross-app reimbursement E2E run against a local API.
// export const API_HOST = process.env.REACT_APP_API_HOST || "https://portal-dev.toothlens.com/api/v1/";

// export const API_HOST = "https://appointment-dev.toothlens.com/api/v1/";


// Annotation service — serves clinic availability. Not derived from API_HOST: it is chosen
// from the portal's own address, so the dev portal (and localhost) talks to UAT and every
// other host — production included — talks to production. No trailing slash; call sites
// add the leading `/`.

// LOCAL DEV - annotation running on :3002. Switch back before committing.
// export const ANNOTATION_API_HOST = "http://localhost:3002/insurance/api/v1";

const PROD_ANNOTATION_API_HOST = "https://annotation.toothlens.com/insurance/api/v1";
const DEV_ANNOTATION_API_HOST = "https://insurance-uat.toothlens.com/insurance/api/v1";

export const ANNOTATION_API_HOST = isDevPortal() ? DEV_ANNOTATION_API_HOST : PROD_ANNOTATION_API_HOST;

// Partner (third-party) API used by the SSO landing page (/sso). It must be the same
// environment that created the sign-in link, so it is chosen from the portal's own
// address rather than toggled by hand. Unknown hosts fall back to ANNOTATION_API_HOST.
const PARTNER_API_HOSTS = {
    "portal.toothlens.com": "https://olivepro.toothlens.com/insurance/api/v1",
    "portal-dev.toothlens.com": "https://insurance-uat.toothlens.com/insurance/api/v1",
    "localhost": "http://localhost:3002/insurance/api/v1",
};

export const PARTNER_API_HOST = PARTNER_API_HOSTS[window.location.hostname] || ANNOTATION_API_HOST;




